import React from 'react';
import useSetChartExport from '@components/export/useSetChartExport';
import { useMetricData } from '../useMetricSeries';
import { useDodData } from '../useDodSeries';
import { pick } from 'lodash';
import useExportMetrics from './useExportMetrics';
import { DATA_TAGS } from '../useData';


function useSetTimeSeriesExport() {

  const exportMetrics = useExportMetrics();

  // metric series
  const { data: metricRows = {}, totals: metricTotals = {} } =  useMetricData({ dataTag: DATA_TAGS.primary });

  // secondary metric series
  const { data: secondaryMetricRows = {}, totals: secondaryMetricTotals = {} } = useMetricData({ dataTag: DATA_TAGS.secondary });

  useSetChartExport({
    pageKey: 'trends',
    sectionKey: 'metrics-panel',
    widgetKey: 'primary-timeseries',
    widgetInfo: { title: 'Timeseries' },
    data: pick({...metricRows, ...secondaryMetricRows}, exportMetrics),
    totals: pick({...metricTotals, ...secondaryMetricTotals}, exportMetrics),
  });

  // dod series
  const { data: dodRows = {}, totals: metricDodTotals = {} } = useDodData({ dataTag: DATA_TAGS.primaryDod });

  // secondary dod series
  const { data: secondaryDodRows = {}, totals: secondaryDodTotals = {} } = useDodData({ dataTag: DATA_TAGS.secondaryDod });

  useSetChartExport({
    pageKey: 'trends',
    sectionKey: 'metrics-panel',
    widgetKey: `dod-timeseries`,
    widgetInfo: {
      title: 'Date Comparison: Timeseries',
    },
    data: pick({...dodRows, ...secondaryDodRows}, exportMetrics),
    totals: pick({...metricDodTotals, ...secondaryDodTotals}, exportMetrics),
  });
}

export default useSetTimeSeriesExport;
